function getUTMParameters() {
  const urlParams = new URLSearchParams(window.location.search)
  const utmParams = {}

  urlParams.forEach((value, key) => {
    if (key.startsWith('utm_')) {
      utmParams[key] = value
    }
  })

  return utmParams
}

function priceToNumber(price) {
  return price ? +(+price).toFixed(2) : 0.0
}

function itemsData(list, catName, prodName, cat) {
  const items = []
  Object.entries(list).map(([k, m]) => {
    items.push({
      index: +k,
      item_brand: cat && cat.super_category ? cat.super_category : null,
      item_category: catName,
      item_name: prodName,
      item_list_id: cat.id,
      item_list_name: cat.name,
      item_variant: m.name,
      item_id: m.id,
      price: priceToNumber(m.cost),
      quantity: m.quantity ? m.quantity : 1,
    })
  })

  return items
}

function getCartProductData(cart, product, loc, menu) {
  if (!cart.totals) return

  const cat = product.data && product.data.category ? menu.categories.find(c => c.name === product.data.category) : null
  const addCat = cat ? cat : menu.categories.find(c => c.products.find(p => p.product_id === product.product_id))
  const quantity = product.data && product.data.quantity ? product.data.quantity : product.quantity

  const items = []

  let cost = product.data && product.data.cost ? product.data.cost : 0
  console.log(product)
  let totalValue = product.data && product.data.cost >= 0 ? product.data.cost * quantity : product.cost.base * quantity
  let superCategory = null
  if (cat && cat.super_category) {
    superCategory = cat.super_category
  } else if (addCat && addCat.super_category) {
    superCategory = addCat.super_category
  }

  if (product.choices && product.choices.length) {
    Object.entries(product.choices).map(([k, m]) => {
      cost = m.cost && m.cost >= 0 ? m.cost : product.cost && product.cost.base ? product.cost.base : 0
      totalValue += cost * quantity
      items.push({
        index: +k,
        item_brand: superCategory,
        item_category: cat ? cat.name : addCat.name,
        item_name: product.data && product.data.name ? product.data.name : product.name,
        item_list_id: cat ? cat.id : addCat.id,
        item_list_name: cat ? cat.name : addCat.name,
        item_variant: m.name,
        item_id: m.id,
        price: priceToNumber(cost),
        quantity: quantity,
      })
    })
  } else {
    cost = product.data && product.data.cost >= 0 ? product.data.cost : product.cost.base
    items.push({
      index: 0,
      item_brand: superCategory,
      item_category: cat ? cat.name : addCat.name,
      item_variant: null,
      item_list_id: cat ? cat.id : addCat.id,
      item_list_name: cat ? cat.name : addCat.name,
      item_name: product.data && product.data.name ? product.data.name : product.name,
      item_id: product.data && product.data.id ? product.data.id : product.id,
      price: priceToNumber(cost),
      quantity: quantity,
    })
  }

  const eventData = {
    ecommerce: {
      currency: 'USD',
      value: priceToNumber(totalValue),
      location_name: loc.name,
      location_code: loc.id,
      items: items,
    },
  }

  return eventData
}

function getCartData(data, loc, menu, payload) {
  if (!data) return

  const eventData = {
    ecommerce: {
      location_name: loc ? loc.name : null,
      location_code: loc ? loc.id : null,
      currency: 'USD',
      coupon: data.coupon ? data.coupon : null,
      tip: data.totals && data.totals.tip ? data.totals.tip : 0,
      tax: data.totals && data.totals.tax ? data.totals.tax : 0,
      value: data.totals && data.totals.subtotal ? data.totals.subtotal : 0,
    },
  }
  if (data && data.products && data.products.length > 0) {
    const items = []

    Object.entries(data.products).map(([k, product]) => {
      const cat = menu ? menu.categories.find(c => c.products.find(p => p.product_id === product.product_id)) : null
      const prodId = cat ? cat.products.find(p => p.product_id === product.product_id).id : product.id
      let cost = product.cost && product.cost.base ? product.cost.base : 0
      if (product.choices && product.choices.length) {
        Object.entries(product.choices).map(([i, m]) => {
          const quantity = m.quantity && m.quantity > 1 ? m.quantity : product.quantity
          cost = m.cost && m.cost >= 0 ? m.cost : product.cost && product.cost.base ? product.cost.base : 0
          items.push({
            index: +k,
            discount: m.discount ? m.discount : null,
            coupon: m.coupon ? m.coupon : null,
            item_brand: cat && cat.super_category ? cat.super_category : null,
            item_category: cat ? cat.name : null,
            item_name: product.name,
            item_list_id: cat ? cat.id : null,
            item_list_name: cat ? cat.name : null,
            item_variant: m.name,
            item_id: m.id,
            price: priceToNumber(cost),
            quantity: quantity,
          })
        })
      } else {
        items.push({
          index: +k,
          discount: product.discount ? product.discount : null,
          coupon: product.coupon ? product.coupon : null,
          item_brand: cat && cat.super_category ? cat.super_category : null,
          item_category: cat ? cat.name : null,
          item_variant: null,
          item_list_id: cat ? cat.id : null,
          item_list_name: cat ? cat.name : null,
          item_id: prodId,
          item_name: product.name,
          price: priceToNumber(product.cost.base),
          quantity: product.quantity,
        })
      }
    })
    eventData.ecommerce.items = items
    if (data && data.paymentType) {
      eventData.ecommerce.payment_type = payload.payment_type
    }

    if (payload && payload.hasOwnProperty('payment_type') && payload.payment_type) {
      eventData.ecommerce.payment_type = payload.payment_type
    }
  }
  return eventData
}

function getShippingInfoData(data, menu) {
  if (!data) return

  const eventData = {
    currency: 'USD',
    value: data.totals && data.totals.subtotal ? data.totals.subtotal : 0,
  }
  if (data && data.products && data.products.length > 0) {
    eventData.items = data.products.map(product => {
      const itemData = {
        item_name: product.name,
        item_id: product.id,
        price: product.cost.total,
        quantity: product.quantity,
      }

      if (menu) {
        const categories = Array.isArray(menu) ? menu : menu.categories || []
        const category = categories.find(c => c.products.find(p => p.product_id === product.product_id))
        itemData.item_category = category.name
        itemData.item_list_id = category.id
        itemData.item_list_name = category.name
        itemData.index = category.products.findIndex(p => p.product_id === product.product_id)
      }

      return itemData
    })
  }
  return eventData
}

function getPaymentInfoData(data) {
  if (!data.cart) return

  const menu = data.menu
  const cart = data.cart

  const eventData = {
    currency: 'USD',
    value: cart.totals && cart.totals.subtotal ? cart.totals.subtotal : 0,
    payment_type: data.paymentType,
    items: cart.products.map(product => {
      const productInCart = cart.products.find(p => p.product_id === product.product_id)
      const cost = productInCart.cost.total ? parseFloat(productInCart.cost.total.toFixed(2)) : 0

      const itemData = {
        item_name: product.name,
        item_id: product.id,
        price: cost,
        quantity: product.quantity,
      }

      if (menu) {
        const categories = Array.isArray(menu) ? menu : menu.categories || []
        const category = categories.find(c => c.products.find(p => p.product_id === product.product_id))
        itemData.item_category = category.name
        itemData.item_list_id = category.id
        itemData.item_list_name = category.name
        itemData.index = category.products.findIndex(p => p.product_id === product.product_id)
      }

      return itemData
    }),
  }

  return eventData
}

function getCategoryProductData(cat, product, loc) {
  if (!product) return
  const items = []
  const quantity = product.data && product.data.quantity ? product.data.quantity : product.quantity

  if (product.mods && product.mods.length > 0) {
    const mods = product.mods.find(i => i.options && i.options.length > 0)
    const catName = product.data && product.data.category ? product.data.category : product.category
    const prodName = product.data && product.data.name ? product.data.name : product.name
    const itemsList = itemsData(mods.options, catName, prodName, cat)

    items.push(...itemsList)
  } else {
    items.push({
      index: 0,
      item_brand: cat && cat.super_category ? cat.super_category : null,
      item_category: product.data && product.data.category ? product.data.category : product.category,
      item_variant: null,
      item_list_id: cat.id,
      item_list_name: cat.name,
      item_name: product.data && product.data.name ? product.data.name : product.name,
      item_id: product.data && product.data.id ? product.data.id : product.id,
      price: product.data && product.data.cost ? priceToNumber(product.data.cost) : priceToNumber(product.cost),
      quantity: quantity ? quantity : 1,
    })
  }

  return {
    ecommerce: {
      item_list_id: cat.id,
      item_list_name: cat.name,
      item_name: product.data && product.data.name ? product.data.name : product.name,
      item_id: product.data && product.data.id ? product.data.id : product.id,
      location_name: loc.name,
      location_code: loc.id,
      items: items,
      value: product.data && product.data.cost ? priceToNumber(product.data.cost) : priceToNumber(product.cost),
    },
  }
}

function getCategoryData(cat, loc) {
  if (!cat) return

  let items = []

  if (cat.products) {
    Object.entries(cat.products).map(([k, p]) => {
      items.push({
        index: +k,
        item_brand: cat && cat.super_category ? cat.super_category : null,
        item_category: p.category,
        item_list_id: cat.id,
        item_list_name: cat.name,
        item_name: p.name,
        item_id: p.id,
        price: parseFloat(p.cost.toFixed(2)),
        quantity: 1,
      })
    })

    return {
      ecommerce: {
        currency: 'USD',
        location_name: loc.name,
        location_code: loc.id,
        item_list_id: cat.id,
        item_list_name: cat.name,
        items,
      },
    }
  } else if (cat.categories) {
    let catIds = []
    let catNames = []
    Object.entries(cat.categories).map(([k, c]) => {
      Object.entries(c.products).map(([k2, p]) => {
        items.push({
          index: +k2,
          item_brand: cat && cat.super_category ? cat.super_category : null,
          item_category: p.category,
          item_list_id: c.id,
          item_list_name: c.name,
          item_name: p.name,
          item_id: p.id,
          price: parseFloat(p.cost.toFixed(2)),
          quantity: 1,
        })
      })
      catIds.push(c.id)
      catNames.push(c.name)
    })

    return {
      ecommerce: {
        currency: 'USD',
        location_name: loc.name,
        location_code: loc.id,
        item_list_id: catIds,
        item_list_name: catNames,
        items,
      },
    }
  }
}

function getProductData(product, loc, menu) {
  if (!product) return
  const catName = product.data && product.data.category ? product.data.category : product.category
  const cat = menu.categories.find(c => c.name === catName)
  const prodName = product.data && product.data.name ? product.data.name : product.name
  const quantity = product.data && product.data.quantity ? product.data.quantity : product.quantity
  const prodId = product.data && product.data.id ? product.data.id : product.id
  const items = []

  if (product.mods && product.mods.length > 0) {
    const mods = product.mods.find(i => i.options && i.options.length > 0)
    const itemsList = itemsData(mods.options, catName, prodName, cat)

    items.push(...itemsList)
  } else {
    items.push({
      index: 0,
      item_brand: cat && cat.super_category ? cat.super_category : null,
      item_category: catName,
      item_variant: null,
      item_list_id: cat.id,
      item_list_name: cat.name,
      item_name: prodName,
      item_id: prodId,
      price: priceToNumber(product.cost),
      quantity: quantity ? quantity : 1,
    })
  }

  return {
    ecommerce: {
      currency: 'USD',
      item_list_id: cat.id,
      item_list_name: cat.name,
      item_name: product.data && product.data.name ? product.data.name : product.name,
      item_id: product.data && product.data.id ? product.data.id : product.id,
      location_name: loc.name,
      location_code: loc.id,
      items: items,
      value: product.data && product.data.cost ? priceToNumber(product.data.cost) : priceToNumber(product.cost),
    },
  }
}

function getPurchaseData(cart, loc, menu, payload) {
  if (!cart || !loc) return

  const eventData = {
    ecommerce: {
      transaction_id: cart.id,
      currency: 'USD',
      value: cart.totals && cart.totals.subtotal ? priceToNumber(cart.totals.subtotal) : 0.0,
      location_name: loc ? loc.name : null,
      location_code: loc ? loc.id : null,
      order_type: cart.handoff,
      coupon: cart.coupon ? cart.coupon : null,
      discounts: cart.discounts && cart.discounts.length > 0 ? cart.discounts : null,
      payment_type: payload.payments && payload.payments[0] && payload.payments[0].type ? payload.payments[0].type : null,
    },
  }
  if (cart && cart.products && cart.products.length > 0) {
    const items = []
    Object.entries(cart.products).map(([k, product]) => {
      const cat = menu ? menu.categories.find(c => c.products.find(p => p.product_id === product.product_id)) : null
      const prodId = cat ? cat.products.find(p => p.product_id === product.product_id).id : product.id
      let cost = product.cost && product.cost.base ? product.cost.base : 0
      if (product.choices && product.choices.length) {
        Object.entries(product.choices).map(([i, m]) => {
          const quantity = m.quantity && m.quantity > 1 ? m.quantity : product.quantity
          cost = m.cost && m.cost >= 0 ? m.cost : product.cost && product.cost.base ? product.cost.base : 0
          items.push({
            index: +k,
            discount: m.discount ? m.discount : null,
            coupon: m.coupon ? m.coupon : null,
            item_brand: cat && cat.super_category ? cat.super_category : null,
            item_category: cat ? cat.name : null,
            item_name: product.name,
            item_list_id: cat ? cat.id : null,
            item_list_name: cat ? cat.name : null,
            item_variant: m.name,
            item_id: m.id,
            price: priceToNumber(cost),
            quantity: quantity,
          })
        })
      } else {
        items.push({
          index: +k,
          discount: product.discount ? product.discount : null,
          coupon: product.coupon ? product.coupon : null,
          item_brand: cat && cat.super_category ? cat.super_category : null,
          item_category: cat ? cat.name : null,
          item_variant: null,
          item_list_id: cat ? cat.id : null,
          item_list_name: cat ? cat.name : null,
          item_id: prodId,
          item_name: product.name,
          price: priceToNumber(product.cost.base),
          quantity: product.quantity,
        })
      }
    })
    eventData.ecommerce.items = items
  }
  return eventData
}

// function getPurchaseData(cart, loc, menu, payload) {
//   if (!cart || !loc) return

//   const eventData = {
//     ecommerce: {
//       order_id: payload ? payload : null,
//       transaction_id: cart.id,
//       currency: 'USD',
//       tip: cart.totals && cart.totals.tip ? cart.totals.tip : 0,
//       tax: cart.totals && cart.totals.tax ? cart.totals.tax : 0,
//       value: cart.totals && cart.totals.total ? cart.totals.total : 0,
//       revenue_center_id: loc.id,
//       revenue_center_name: loc.name,
//       service_type: cart.handoff,
//     },
//   }
//   if (cart && cart.products && cart.products.length > 0) {
//     eventData.ecommerce.items = cart.products.map(product => {
//       // Get Menu cat of purchased products
//       let item_category = null
//       if (menu && 'categories' in menu) {
//         menu.categories.map(c => {
//           c.products.map(p => {
//             if (p.product_id === product.product_id) {
//               item_category = c.name
//             }
//           })
//         })
//       } else if (menu) {
//         for (var x in menu) {
//           menu[x].products.map(p => {
//             if (p.product_id === product.product_id) {
//               item_category = menu[x].name
//             }
//           })
//         }
//       }

//       return {
//         item_id: product.id,
//         item_name: product.name,
//         price: product.cost.total ? parseFloat(product.cost.total.toFixed(2)) : 0,
//         quantity: product.quantity,
//         item_category,
//       }
//     })
//   }
//   return eventData
// }

function getLocationData(location) {
  if (!location) return
  return {
    locations: [
      {
        name: location.name,
        address: location.address,
        city: location.city,
        state: location.state,
        zip: location.zip,
        services: location.services,
      },
    ],
  }
}

function getLocationResultsData(locations) {
  if (!locations.length) {
    return { locations: null }
  }
  let data = []

  locations.map(l => {
    data.push({
      store_id: l.id,
      store_name: l.name,
      store_city: l.city,
      store_state: l.state,
      store_address: l.address,
      store_zip: l.zip,
    })
  })

  return {
    locations: data,
  }
}

function getLoginUserData(payload, user) {
  if (!user) return
  console.log('payload: ', payload)

  const response = payload.user ? payload.user : payload
  const data = user ? user : response

  return {
    ecommerce: {
      user: {
        user_id: data.id,
      },
    },
  }
}

function getLoginMagicLinkData(payload) {
  const loggedUserId = payload.user ? payload.user.id : null
  const loggedUserEmail = payload.email_hash ? payload.email_hash : null
  const requestEmail = payload.email ? payload.email : null
  let response = null

  if (loggedUserId && loggedUserEmail) {
    response = {
      userId: loggedUserId,
      properties: {
        email_hash: loggedUserEmail,
        timestamp: new Date().toISOString(),
        platform: 'web',
      },
    }
  } else if (requestEmail && !loggedUserId) {
    response = {
      properties: {
        email: requestEmail,
        timestamp: new Date().toISOString(),
        platform: 'web',
      },
    }
  }
  return response
}

function getCustomizeItemData(payload) {
  return {
    ecommerce: {
      item_id: payload.item_id,
      customization_type: payload.customization_type,
      customization_type_id: payload.customization_type_id,
      customization_value: payload.customization_value,
      customization_value_id: payload.customization_value_id,
      action: payload.action,
      price_change: payload.price_change,
    },
  }
}

function getOrderTypeChangedData(payload) {
  return {
    ecommerce: {
      previous_order_type: payload.previous_order_type,
      new_order_type: payload.new_order_type,
      location_id: payload.location_id,
    },
  }
}

function getTipSelectedData(payload) {
  return {
    ecommerce: {
      tip_amount: payload.tip_amount,
      tip_percentage: payload.tip_percentage,
    },
  }
}

function getCouponAppliedData(payload) {
  return {
    ecommerce: {
      coupon_code: payload.coupon_code,
      status: payload.status,
      failure_reason: payload.failure_reason,
      discount_amount: payload.discount_amount,
    },
  }
}

function getSearchResultsData(payload) {
  return {
    ecommerce: {
      search_term: payload.search_term,
      results_count: payload.results_count,
      no_results: payload.no_results,
    },
  }
}

function getSignInAttemptData(payload) {
  return {
    ecommerce: {
      status: payload.status,
      failure_reason: payload.failure_reason,
      location: payload.location,
    },
  }
}

function getContinueAsGuestData(payload) {
  return {
    ecommerce: {
      guest_details: payload.guest,
      location: payload.location,
    },
  }
}

function pushDataLayer(event, window) {
  if (!window || !event) return
  window.dataLayer = window.dataLayer || []
  dataLayer.push({
    ecommerce: null,
    locations: null,
    order_type: null,
  }) // Clear previous data layer data
  window.dataLayer.push(event)
}

function pushEvent(name, payload = {}, window, location = {}, cart = {}, user = {}, tracking = true, menu = {}, affiliation = 'default', has_group_order = false, group_order = 'no') {
  if (!name || !window) return
  let data = { event: name }

  switch (name) {
    // ecommerce tracking

    case 'view_item_list':
      data = { ...data, ...getCategoryData(payload, location) }
      data.ecommerce.affiliation = affiliation
      break

    case 'view_item':
      data = { ...data, ...getProductData(payload, location, menu) }
      if (has_group_order) {
        data.ecommerce.group_order = group_order
      }
      data.ecommerce.affiliation = affiliation
      break

    case 'select_item':
      data = {
        ...data,
        ...getCategoryProductData(payload.category, payload.prod, location),
      }
      data.ecommerce.affiliation = affiliation
      break

    case 'remove_from_cart':
      if (payload.cart || payload.menu) {
        // Means event is coming from trackEvent action and cart and menu are passed in payload, in all other cases, payload is just the product
        cart = payload.cart
        menu = payload.menu
      }
      data = { ...data, ...getCartProductData(cart, payload, location, menu) }
      if (has_group_order) {
        data.ecommerce.group_order = group_order
      }
      data.ecommerce.affiliation = affiliation
      break
    case 'add_to_cart':
      if (payload.cart || payload.menu) {
        // Means event is coming from trackEvent action and cart and menu are passed in payload, in all other cases, payload is just the product
        cart = payload.cart
        menu = payload.menu
      }
      data = { ...data, ...getCartProductData(cart, payload, location, menu) }
      if (has_group_order) {
        data.ecommerce.group_order = group_order
      }
      data.ecommerce.affiliation = affiliation
      break

    case 'update_product':
      data = { ...data, ...getCartProductData(cart, payload, location, menu) }
      data.ecommerce.affiliation = affiliation
      break

    case 'view_cart':
      data = { ...data, ...getCartData(payload, location, menu) }
      data.ecommerce.affiliation = affiliation
      break

    case 'begin_checkout':
      data = { ...data, ...getCartData(cart, location, menu) }
      if (has_group_order) {
        data.ecommerce.group_order = group_order
      }
      break

    case 'purchase':
      data = { ...data, ...getPurchaseData(cart, location, menu, payload) }
      if (has_group_order) {
        data.ecommerce.group_order = group_order
      }
      if (data.ecommerce && affiliation) {
        data.ecommerce.affiliation = affiliation
      }
      break

    // non ecommerce tracking

    case 'view_store_list':
      data = { ...data, ...getLocationResultsData(payload) }
      break

    case 'location_favorited':
      data = { ...data, ...getLocationData(payload) }
      break

    case 'select_location':
      data = { ...data, ...getLocationData(payload) }
      break

    case 'view_estimated_ready':
      data.time = payload
      break

    case 'set_order_time':
      data.time = payload
      break

    case 'upsell_added_to_cart':
      data.name = payload
      break

    case 'created_at':
      data.time = payload
      break

    case 'city':
      data.city = payload
      break

    case 'sign_in':
      if (payload.method) {
        data = { ...data, ...payload }
      } else {
        data = { ...data, ...getLoginUserData(payload, user) }
      }
      break

    case 'add_shipping_info':
      data = { ...data, ...getCartData(cart, location, menu) }
      break

    case 'add_payment_info':
      data = { ...data, ...getPurchaseData(cart, location, menu, payload) }
      if (data.ecommerce && affiliation) {
        data.ecommerce.affiliation = affiliation
      }
      break

    case 'magic_link_sent':
      data = { ...data, ...getLoginMagicLinkData(payload) }
      break

    case 'magic_link_login':
      data = { ...data, ...getLoginMagicLinkData(payload) }
      break

    case 'customize_item':
      data = { ...data, ...getCustomizeItemData(payload) }
      break

    case 'order_type_changed':
      data = { ...data, ...getOrderTypeChangedData(payload) }
      if (data.ecommerce.order_type) {
        data.ecommerce.order_type = payload.new_order_type
      } else {
        data.order_type = payload.new_order_type
      }
      break

    case 'tip_selected':
      data = { ...data, ...getTipSelectedData(payload) }
      break

    case 'coupon_applied':
      data = { ...data, ...getCouponAppliedData(payload) }
      break

    case 'view_search_results':
      data = { ...data, ...getSearchResultsData(payload) }
      break

    case 'sign_in_attempt':
      data = { ...data, ...getSignInAttemptData(payload) }
      break

    case 'continue_as_guest':
      data = { ...data, ...getContinueAsGuestData(payload) }
      break

    default:
      break
  }

  if (cart && cart.handoff) {
    if (data.ecommerce) {
      data.ecommerce.order_type = cart.handoff
    } else {
      data.order_type = cart.handoff
    }
  }

  if (user && user.id) {
    if (data.ecommerce) {
      data.ecommerce.user = {
        user_id: user.id,
      }
    } else {
      data.user = {
        user_id: user.id,
        user_first_name: user.first_name,
        user_last_name: user.last_name,
        user_phone: user.phone,
        user_email: user.email,
      }
    }
  }

  // Extract UTM parameters and add them to the data object
  const utmParams = getUTMParameters()
  if (Object.keys(utmParams).length > 0) {
    data = { ...data, utmParams }
  }

  if (tracking && process.env.NODE_ENV === 'development') {
    console.log('=========>: tracking event data: ', name, data)
  } else if (!tracking && process.env.NODE_ENV === 'development') {
    console.log('=========>: NOT TRACKING IN LIBRARY')
  }

  if (tracking) {
    pushDataLayer(data, window)
  }
}
module.exports = {
  pushEvent,
}
